var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"in-dm-message",class:`in-dm-message--${_vm.side}`},[_c('div',{staticClass:"in-dm-message__bubble"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }